module.exports = __webpack_public_path__ + "img/moto.65519e4a.png";